import request from '@/utils/request';

let getAllMenu=()=>request.post('/api/menu/list',{pageIndex:1,pageSize:-1})
let getMenuList=(data)=>request.post('/api/menu/list',data)
let addMenu=(data)=>request.post('/api/menu/add',data)
let editMenu=(data)=>request.post('/api/menu/edit',data)
let deleteMenu=(data)=>request.get('/api/menu/delete',data)
let getUserMenu=()=>request.get('/api/menu/get')

export default {
  getAllMenu,
  getMenuList,
  addMenu,
  editMenu,
  deleteMenu,
  getUserMenu
}